import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import type { BrowserOptions } from "@sentry/react";
import App from "./App";
import { ErrorBoundary } from "./components/ErrorBoundary";
import "./index.css";

const sentryDsn = import.meta.env.VITE_SENTRY_DSN;

if (sentryDsn) {
  const release =
    import.meta.env.VITE_SENTRY_RELEASE ||
    import.meta.env.VITE_GIT_COMMIT ||
    undefined;
  const environment =
    import.meta.env.VITE_SENTRY_ENVIRONMENT ||
    import.meta.env.MODE ||
    (import.meta.env.DEV ? "development" : "production");
  const tracesSampleRateRaw = import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE;
  const tracesSampleRate = tracesSampleRateRaw
    ? Number.parseFloat(tracesSampleRateRaw)
    : undefined;

  const options: BrowserOptions = {
    dsn: sentryDsn,
    environment,
    integrations: [],
    sendDefaultPii: false,
  };
  if (release) {
    options.release = release;
  }
  if (tracesSampleRate !== undefined && Number.isFinite(tracesSampleRate)) {
    options.tracesSampleRate = tracesSampleRate;
  }

  Sentry.init(options);
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ErrorBoundary level="app">
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
);
